interface IQuestion{
    id: number;
    question: string;
}

export const questions : IQuestion[] = [
    {
        id: 1,
        question: 'Ik wil meteen aan de slag.'
    },
    {
        id: 2,
        question: 'Ik wil een luisterend oor.'
    },
    {
        id: 3,
        question: 'Ik wil meer informatie wat ik kan doen bij schulden.'
    },
    {
        id: 4,
        question: 'Ik wil iemand die het samen met mij doet.'
    },
    {
        id: 5,
        question: 'Ik wil het zelf oplossen.'
    },
    {
        id: 6,
        question: 'Ik wil mijn gegevens wel delen.'
    },
    {
        id: 7,
        question: 'Ik wil buiten noord geholpen worden.'
    }
];